module.exports = __webpack_public_path__ + "0424d47d4d06585a810a759baa0f81e3.svg";